import ReactPlayer from 'react-player/lazy'
import reactPlayerConfig from '../../lib/reactPlayerConfig'
import useUser from '../../lib/useUser'
import { useAnalytics } from '../context/AnalyticsProvider'

export default function CLReactPlayer({
  config,
  trackingEventPrefix = 'video',
  onStart,
  onEnded,
  ...props
}) {
  const { user } = useUser()
  const { trackData } = useAnalytics()

  const mergedConfig = config
    ? { ...reactPlayerConfig, ...config }
    : reactPlayerConfig

  const handleStart = () => {
    trackData(`${trackingEventPrefix}_played`, {
      user,
      video: { url: props.url },
      played_at: new Date().toISOString(),
    })
    onStart?.()
  }

  const handleEnded = () => {
    trackData(`${trackingEventPrefix}_ended`, {
      user,
      video: { url: props.url },
      ended_at: new Date().toISOString(),
    })
    onEnded?.()
  }

  return (
    <ReactPlayer
      controls
      width="100%"
      height="100%"
      config={mergedConfig}
      onStart={handleStart}
      onEnded={handleEnded}
      {...props}
    />
  )
}
